export const UNSUPPORTED_COLUMNS = new Set(["subtasks", "dependency", "dropdown", "file"]);
